import dispatchEvent from '../utils/dispatch-event.js';

class InsuranceActivator extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.initEventListeners();
    });
  }

  get checkbox() {
    return this.querySelector('input[type="checkbox"]');
  }

  get lineIndex() {
    return this.dataset.lineIndex;
  }

  get currentProperties() {
    return Object.fromEntries(JSON.parse(this.dataset.currentProperties));
  }

  changeInsurance() {
    fetch('/cart/change.js', {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      method: 'POST',
      body: JSON.stringify({
        line: this.lineIndex,
        properties: {
          ...this.currentProperties,
          _free_insurance_email: this.checkbox.checked,
        },
      }),
    }).then(() => {
      dispatchEvent('cart:properties-updated', document);
    });
  }

  updateCheckbox() {
    this.changeInsurance();
  }

  initEventListeners() {
    this.checkbox.addEventListener('click', () => this.updateCheckbox());
  }
}

customElements.define('insurance-activator', InsuranceActivator);
